import AssignCell from 'components/molecules/rpm-overview-table/components/columns/assign';
import LatestReading from 'components/molecules/rpm-overview-table/components/columns/latest-reading';

import PatientCell from './patient-cell';
import s from './styles.module.scss';

import type { IAssignTool } from 'infrastructure/interfaces';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

export const useColumns = (
  toggleOpen: () => void,
  isLoadingReadings = false,
): IBaseTableColumns<IAssignTool> => {
  return [
    {
      key: 'guid',
      width: '439px',
      render(guid: string, record) {
        return (
          <PatientCell
            name={record.name}
            guid={record.guid}
            dob={record.dob}
            language={record.language}
            provider={record.provider}
            rpmStatus={record.latestReading?.rpmStatus}
            ccmStatus={record.latestReading?.ccmStatus}
            isLoadingProgramType={isLoadingReadings}
            toggleOpen={toggleOpen}
          />
        );
      },
      dataCy: 'assign-tool-table-patient-info',
    },
    {
      width: '300px',
      key: 'guid',
      dataCy: 'assign-tool-table-options',
      render(guid: string, record) {
        return (
          <LatestReading
            id={record.latestReading?.patientGuid}
            values={record.latestReading?.value}
            statuses={record.latestReading?.statuses}
            createdAt={record.latestReading?.createdAt}
            isLoading={isLoadingReadings}
            isDisplayTimestampVertically
          />
        );
      },
    },
    {
      width: '99px',
      key: 'guid',
      dataCy: 'assign-tool-table-options',
      render(guid: string, record) {
        return (
          <div className={s['assign-cell-wrapper']}>
            <AssignCell
              patientGuid={record.guid}
              assignee={record.assignee}
              isInsideAssignedDrawer
            />
          </div>
        );
      },
    },
  ];
};
